import Halal from '../assets/foodAttributes/Halal.png';
import Takeaway from '../assets/foodAttributes/Take Away.png'

export const dateTFormat = (date: Date) => {
    function formatDate(date: Date): string {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const paddedMonth = month.toString().padStart(2, "0");
        const paddedDay = day.toString().padStart(2, "0");
        return `${year}-${paddedMonth}-${paddedDay}`;
    }
    return formatDate(date);
};

export const formatTime = (dateString: string): string => {
    const date = new Date(dateString);
    const hour = date.getHours();
    const minute = date.getMinutes();
    return `${hour}:${minute}hrs`;
};

export function capitalizeFirstLetter(string: string): string {
    if (!string) return string;
    return string
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
}

export const categoryTagsOptionsFunction = (data: any) => {
    if (data && data.categoryList && data.categoryList.categories) {
        const categoryArray = data.categoryList.categories;
        return categoryArray.map((item: any) => {
            return {
                value: capitalizeFirstLetter(item.display),
                label: capitalizeFirstLetter(item.display),
            };
        });
    } else {
        console.error("Invalid data structure:", data);
        return [];
    }
};

// Utility function to capitalize the first letter
const capitalizeFirstLetterEdit = (string: string) => {
    return string?.charAt(0)?.toUpperCase() + string?.slice(1);
};

// Modified categoryTagsOptionsFunction to capitalize the first letter
export const categoryTagsOptionsFunctionEdit = (data: any) => {
    if (data && data.categoryList && data.categoryList.categories) {
        const categoryArray = data.categoryList.categories;
        const categoryTagsOptions = categoryArray.map((item: any) => {
            const capitalizedDisplay = capitalizeFirstLetterEdit(item.display);
            return { value: capitalizedDisplay, label: capitalizedDisplay };
        });
        return categoryTagsOptions;
    } else {
        console.error("Invalid data structure:", data);
        return [];
    }
};

//Getting Button Variant According to status

export const getOptionVariant = (label: string) => {
    switch (label) {
        case "Rejected":
        case "Deleted":
            return "danger";
        case "Approved":
            return "success";
        case "Pending":
            return "warning";
        default:
            return "primary";
    }
};

export const InventoryId = (date: any) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}${month}${day}`;
};

export const restaurantPropertiesFunction = (data: any) => {
    if (data && data.RestaurantPropertiesList) {
        const restauarntPropertiesArray = data.RestaurantPropertiesList;
        return restauarntPropertiesArray.map((item: any) => {
            return {
                value: capitalizeFirstLetter(item.displayName),
                label: capitalizeFirstLetter(item.displayName),
            };
        });
    } else {
        console.error("Invalid data structure:", data);
        return [];
    }
};

export const formatTimestamp = (timestamp?: { _seconds: number }): string => {
    if (!timestamp) {
        return "N/A";
    }
    const date = new Date(timestamp._seconds * 1000);
    return date.toLocaleString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
    });
};

export const dateMonthYearTemp = (rowDate: any) => {

    const date = new Date(rowDate * 1000);
    const day = date.getDate().toString().padStart(2, '0');
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Agu', 'Sept', 'Oct', 'Nov', 'Dec'];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;

}

export const getImageUrl = (displayName: string): string => {
    switch (displayName) {
        case "Halal":
            return Halal;

        case "Takeaway":
            return Takeaway;

        default:
            return "https://th.bing.com/th/id/OIP.6ktsOLcDR81pbfsloxnSngHaHa?w=165&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7";
    }
};

export const getLocalDateString = (date = new Date()) => {
  const offsetDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return offsetDate.toISOString().split('T')[0];
};